// import dependencies
import states from '../util/states.json';
import Form from './form';

// return Stepper class
export default class Stepper extends Form {
    constructor(elem, settings) {
        super(elem, settings);

        this.questionnaireId = parseInt(elem.dataset.questionnaireid);
        this.currentCategory = 1;
        this.currentQuestion = 1;
        this.categoryLength = this.json.data.length;
        this.questionsAnswered = [];

        this.selectedState = '';
        this.countiesList = [];
        this.selectedCounty = '';

        let form = document.createElement('form');
        form.classList.add('stepper');

        // store element reference
        this.form = this.elem.appendChild(form);

        // render initial list of users
        this.renderList();

        this.initialized = false;
    }

    // initialize plugin
    init() {
        if (this.thankYouSlide) {
            this.renderThankYouSlide();
        }

        let firstQuestionHeight = document.querySelectorAll(`.category-0-question-0`)[0].clientHeight;
        document.getElementsByClassName('stepper')[0].style.height = firstQuestionHeight + 5 + 'px';


        let finalQuestion = document.querySelectorAll(`.category-${this.json.data.length - 1}-question-${this.json.data[this.json.data.length - 1][this.json.questionArray].length - 1} .stepper-group-btns .next-btn`)[0]
        finalQuestion.innerText = 'Finish';
        finalQuestion.dataset.btn = 'finish';

        $(":input").inputmask({
            showMaskOnFocus: true,
            clearMaskOnLostFocus: true
        });

        // loop through and bind buttons
        this.bindButtonClicks();

        // set initialized to `true`
        this.initialized = true;
    }

    bindButtonClicks() {
        let buttons = document.querySelectorAll('.stepper-group-btns button');

        for (let button of buttons) {
            button.addEventListener('click', (e) => { this.handleButtonClick(e); }, true);
        }
    }

    handleButtonClick(e) {
        let target = e.target;
        let questionGroup = target.closest('.stepper-group');
        let categoryGroup = target.closest('.category');

        if (target.dataset.btn === 'reload') {
            window.location.reload(true);
            return;
        }
        
        let index = parseInt(questionGroup.dataset.index);
        let categoryIndex = parseInt(categoryGroup.dataset.index);

        let questionType = this.convertType(this.json.data[categoryIndex][this.json.questionArray][index][this.json.questionType]);
        let id = this.json.data[categoryIndex][this.json.questionArray][index][this.json.questionId];
        
        let input = questionType !== 'TrueFalse' ? questionGroup.querySelectorAll('.form-control')[0] : questionGroup.querySelectorAll(`input[name="question-${this.json.data[categoryIndex][this.json.questionArray][index][this.json.questionId]}"]`);

        // remove current errors if they exist
        questionGroup.classList.remove('form-error');
        questionGroup.querySelectorAll('.field-validation')[0] !== undefined ? questionGroup.querySelectorAll('.field-validation')[0].innerText = '' : null;

        let nextQuestion = null;

        if (target.dataset.btn === 'finish') {
            if (this.validateInput(input, questionType)) {
                // send results to api
                //{apiUrl}/questionnaire/participants

                //console.log(document.getElementById(`yes-question-9999`).checked);

                let results = {
                    'firstName': document.getElementById(`question-9991`).value,
                    'lastName': document.getElementById(`question-9992`).value,
                    'questionnaireId': this.questionnaireId,
                    'isOptedIn': document.getElementById(`yes-question-9999`).checked ? true : false,
                    'referrerId': 1,
                    'address1': document.getElementById(`question-9993`).value,
                    'city': document.getElementById(`question-9994`).value,
                    'state': document.getElementById(`question-9995`).value,
                    'zipcode': document.getElementById(`question-9996`).value,
                    'emailAddress': document.getElementById(`question-9998`).value,
                    'phoneNumber': document.getElementById(`question-9997`).value,
                    'answers': []
                };

                // remove last category from html
                document.getElementsByClassName('category-9999')[0].remove();

                // loop through all questions and if value, add to array
                for (let element of this.form.elements) {
                    let type = element.getAttribute('type');

                    if (type !== 'button') {
                        if (type === 'radio') {
                            if (element.checked) {
                                results.answers.push({ answer: element.value, questionId: parseInt(element.dataset.id) });
                            }
                        }
                        else if (element.value !== '') {
                            results.answers.push({ answer: element.value, questionId: parseInt(element.dataset.id) });
                        }
                    }
                }

                fetch(this.formActionUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(results),
                })
                    .then((response) => {
                        return response.json();
                    })
                    .catch((error) => console.log(error));

                // show thank you page
                questionGroup.classList.add('complete-step');
                questionGroup.classList.remove('active');

                setTimeout(() => {
                    window.location.reload(true);
                }, 5000);

                let thankYouPage = document.getElementsByClassName('thank-you-slide')[0];
                thankYouPage.classList.add('active');
                thankYouPage.classList.remove('hide-step');
            }
            else {
                // display error
                let required = input.dataset.required;
                let validation = input.dataset.regexvalidation;

                questionGroup.classList.add('form-error');

                if (validation != undefined && validation != 'undefined') {
                    questionGroup.querySelectorAll('.field-validation')[0].innerText = 'This field is not valid';
                }
                else {
                    questionGroup.querySelectorAll('.field-validation')[0].innerText = required;
                }
            }
        }
        else if (target.dataset.btn === 'next') {
            if (this.validateInput(input, questionType)) {
                questionGroup.classList.add('complete-step');
                questionGroup.classList.remove('active');

                // if state type, update variable
                if (questionType === 'StateSelect') {
                    this.selectedState = input.value;

                    this.getUpdatedCounties();
                }
                if (questionType === 'CountySelect') {
                    this.selectedCounty = input.value;
                }

                // find next question
                nextQuestion = this.getQuestion(index, categoryIndex, true);
                nextQuestion.classList.add('active');
                nextQuestion.classList.remove('hide-step');

                // add current question to list
                this.questionsAnswered.push(questionGroup);
            }
            else {
                // display error
                let required = input.dataset.required;
                let validation = input.dataset.regexvalidation;

                questionGroup.classList.add('form-error');

                if (validation != undefined && validation != 'undefined') {
                    questionGroup.querySelectorAll('.field-validation')[0].innerText = 'This field is not valid';
                }
                else {
                    questionGroup.querySelectorAll('.field-validation')[0].innerText = required;
                }
            }
        }
        else if (target.dataset.btn === 'previous') {
            questionGroup.classList.add('hide-step');
            questionGroup.classList.remove('active');

            // find previous question
            nextQuestion = this.questionsAnswered[this.questionsAnswered.length - 1];
            nextQuestion.classList.add('active');
            nextQuestion.classList.remove('complete-step');

            // remove question from list
            this.questionsAnswered.splice(-1, 1);
        }
       
        // update height of stepper for new question
        if (nextQuestion != null) {
            document.getElementsByClassName('stepper')[0].style.height = nextQuestion.clientHeight + 5 + 'px';
        }
    }

    getCategoryGroupHtml(category, categoryIndex) {
        let div = document.createElement('div');
        div.classList.add('category', `category-${category[this.json.categoryId]}`);
        div.dataset.id = category[this.json.categoryId];
        div.dataset.index = categoryIndex;

        let html = '';

        let questionHTML = category[this.json.questionArray].map((question, index) => this.getQuestionHtml(question, index, categoryIndex));

        for (let question of questionHTML) {
            html += question;
        }

        div.innerHTML = html;

        return div;
    }

    getUpdatedCounties() {
        fetch(`${window.lhfs.ApiBaseUrl}/Location/counties?state=${this.selectedState}`)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.countiesList = data;

                let options = '<option value="">Select an option</option>';

                for (let option of this.countiesList) {
                    options += `<option value="${option.countyName}">${option.countyName}</option>`
                }

                if (this.selectedCounty !== '') {
                    $('.county-select').html(options);
                    $('.county-select').val(this.selectedCounty);
                }
                else {
                    $('.county-select').html(options);
                }
                
            })
            .catch((error) => console.log(error));
    }

    // return `li` element with user fullname
    getQuestionHtml(question, index, categoryIndex) {       
        let type = this.convertType(question[this.json.questionType]);
        let html = `<div class="stepper-group question-id-${question[this.json.questionId]} category-${categoryIndex}-question-${index} ${index === 0 && categoryIndex === 0 ? 'active' : 'hide-step'}" 
                        data-index=${index} 
                        data-id=${question[this.json.questionId]}>
                    <label for="question-${question[this.json.questionId]}">${question[this.json.questionText]}</label>`;

        
        if (type === 'OptionSelect') {
            html += this.createSelect(`${question[this.json.questionId]}`, question[this.json.answerOptions], question[this.json.isOptional]);
        }
        else if (type === 'StateSelect') {
            html += this.createSelect(`${question[this.json.questionId]}`, states, question[this.json.isOptional]);
        }
        else if (type === 'CountySelect') {
            html += this.createCountySelect(`${question[this.json.questionId]}`, [], question[this.json.isOptional]);
        }
        else if (type === 'TextAreaEntry') {
            html += this.createTextarea(`${question[this.json.questionId]}`, question[this.json.isOptional]);
        }
        else if (type === 'TrueFalse') {
            html += this.createTrueFalse(`${question[this.json.questionId]}`);
        }
        else {
            html += this.createInput(`${question[this.json.questionId]}`, type, question[this.json.regexValidation], question[this.json.isOptional]);
        }

        if (type !== 'Terminator') {
            // for now assume the first question never has a prerequisite
            if (index === 0 && categoryIndex === 0) {
                html += `
                    <div class="stepper-group-btns">
                            <button data-btn="previous" class="previous-btn disabled" disabled type="button">Previous</button>
                            <button data-btn="next" class="next-btn" type="button">Next</button>
                        </div>
                    </div>`;
            }
            else {
                html += `
                    <div class="stepper-group-btns">
                        <button data-btn="previous" class="previous-btn" type="button">Previous</button>
                        <button data-btn="next" class="next-btn" type="button">Next</button>
                    </div>
                </div>`;
            }
        }
        else {
            html += `
                    <div class="stepper-group-btns">
                        <button data-btn="previous" class="previous-btn" type="button">Previous</button>
                    </div>
                </div>`;
        }
        

        return html;
    }

    // append `li` element to the users `ul` element
    appendDiv(div) {
        this.form.appendChild(div);
    }

    renderThankYouSlide() {
        let div = document.createElement('div');
        div.classList.add('category', 'thank-you-slide', 'hide-step', 'stepper-group');

        let html = `<h2>${this.thankYouTitle}</h2>
            <div class="description">${this.thankYouText}</div>`;

        div.innerHTML = html;

        this.appendDiv(div);
    }

    convertType(type) {
        for (let [key, value] of Object.entries(this.questionTypes)) {
            if (value === type) {
                return key;
            }
        }
    }

    // render entire categories list
    renderList() {
        let groupElements = this.json.data.map((categories, index) => this.getCategoryGroupHtml(categories, index));

        for (let div of groupElements ){
            this.appendDiv(div);
        }
    }

    // add new category
    addCategory(category) {
        let categoryHtml = this.getCategoryGroupHtml(category, this.categoryLength);

        this.categoryLength++;

        this.appendDiv(categoryHtml);

        this.json.data.push(category);
    }
}